import { Box } from '@mui/material';

export const ImageCell = ({ params, onImgClick }) => {
  const photos = params.value || [];
  const firstImage = photos[0] ? photos[0] : null;
  const remainingCount = photos.length - 1;

  return (
    <Box display="flex" paddingTop={0.7} alignItems="center" gap={1}>
      {firstImage && (
        <img
          src={firstImage}
          alt="Displayed Tickets"
          style={{ width: 40, height: 40, objectFit: 'cover', cursor: 'pointer', borderRadius: 4 }}
          onClick={() => onImgClick(photos)} // Pass the whole array for carousel display
        />
      )}
      {remainingCount > 0 && (
        <Box
          sx={{
            width: 40,
            height: 40,
            backgroundColor: '#ccc',
            color: 'black',
            borderRadius: 4,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
          }}
          onClick={() => onImgClick(photos)}
        >
          +{remainingCount}
        </Box>
      )}
    </Box>
  );
};
